/* eslint-disable no-unused-expressions */
import { useState, useEffect, useRef } from 'react'
import { useLesson, useLessons } from 'querys/lesson'
import getLessonNumber from 'utils/get-lessson-number'
import { TransparentButton } from 'common/button'
import Vimeo from './vimeo'
import Youtube from './youtube'
import VideoOverlay from './video-overlay'
import LessonVideoStyled from './lesson-video-styled'

function LessonVideo() {
  const {
    data: {
      title,
      video,
      thumbnails,
    },
    token,
  } = useLesson()
  const [width, setWidth] = useState(0)
  const observerRef = useRef(null)
  const videoRef = useRef(null)
  const { data: lessons } = useLessons()

  const handleEnter = () => {
    videoRef.current?.classList.add('video-fixed')
  }

  const handleLeave = () => {
    videoRef.current?.classList.remove('video-fixed')
  }

  useEffect(() => {
    Promise.resolve(
      typeof window.IntersectionObserver !== 'undefined'
        ? window.IntersectionObserver
        : import('intersection-observer'),
    ).then(() => {
      if (observerRef.current) {
        const observerOptions = {}
        const observer = new window.IntersectionObserver((entries) => {
          if (!observerRef.current) return
          const data = entries[0]
          const { width: containerWidth } = observerRef.current.getBoundingClientRect()
          setWidth(containerWidth)
          const { boundingClientRect: { y } } = data
          const bigScreen = window.matchMedia('(min-width: 1024px)').matches
          if (y <= 70 && bigScreen) {
            handleEnter()
          } else if (y < 0 && !bigScreen) {
            handleEnter()
          } else if (y > 0 && !bigScreen) {
            handleLeave()
          } else {
            handleLeave()
          }
        }, observerOptions)
        observer.observe(observerRef.current, observerOptions)
      }
    })
  }, [observerRef.current])

  const handleVideoResize = () => {
    const videoItem = document.querySelector('.video-container')
    if (videoItem.classList.contains('video-fixed')) {
      videoItem.classList.remove('video-fixed')
    } else {
      videoItem.classList.add('video-fixed')
    }
  }

  if (video?.player_url?.includes('vimeo') && token) {
    return (
      <LessonVideoStyled width={width}>
        <div className="video-observer" ref={observerRef} />
        <div className="video-container" ref={videoRef}>
          <div className="video-fixed-controls">
            <p>
              <span className="video-fixed-number">
                {getLessonNumber(lessons, title)}
                {'.'}
              </span>
              {title}
            </p>
            <TransparentButton onClick={() => handleVideoResize()}>
              <img src="/images/icons/external-link.png" width="24" height="24" alt="Icono para volver el video a pantalla completa" />
            </TransparentButton>
          </div>
          <Vimeo progress_time={video?.progress} url_vimeo={video?.player_url} />
        </div>
      </LessonVideoStyled>
    )
  }

  if (video?.player_url?.includes('youtube') && token) {
    return (
      <LessonVideoStyled width={width}>
        <div className="video-observer" ref={observerRef} />
        <div className="video-container" ref={videoRef}>
          <Youtube progress_time={video?.progress} id_youtube={video?.provider_id} />
        </div>
      </LessonVideoStyled>
    )
  }

  return (
    <LessonVideoStyled>
      <VideoOverlay thumbnails={thumbnails} />
    </LessonVideoStyled>
  )
}

export default LessonVideo
